import { render, staticRenderFns } from "./insuredNotice.vue?vue&type=template&id=5005cfba&scoped=true&"
import script from "./insuredNotice.vue?vue&type=script&lang=js&"
export * from "./insuredNotice.vue?vue&type=script&lang=js&"
import style0 from "./insuredNotice.vue?vue&type=style&index=0&id=5005cfba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005cfba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5005cfba')) {
      api.createRecord('5005cfba', component.options)
    } else {
      api.reload('5005cfba', component.options)
    }
    module.hot.accept("./insuredNotice.vue?vue&type=template&id=5005cfba&scoped=true&", function () {
      api.rerender('5005cfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/insuredNotice.vue"
export default component.exports